var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',_vm._l((_vm.splitted),function(e,idx){return _c('span',{key:`email-${idx}`,staticStyle:{"padding-left":"3px"}},[_c('a',{attrs:{"href":'mailto:'+e}},[_vm._v(_vm._s(e))]),(idx!=_vm.splitted.length-1)?[_vm._v(" | ")]:_vm._e()],2)}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }